module.exports = __webpack_public_path__ + "static/media/black_swan_opt.1d794f00.png";